import React from 'react';

interface NavItemProps {
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
  mobile?: boolean;
}

const NavItem = ({ href, children, onClick, mobile = false }: NavItemProps) => {
  const baseClasses = "text-sm font-medium text-gray-700 transition-colors duration-200";
  const desktopClasses = "px-6 py-3 bg-[#D9D9D9] hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-inset";
  const mobileClasses = "block px-6 py-3 hover:bg-gray-100";

  return (
    <a
      href={href}
      className={`${baseClasses} ${mobile ? mobileClasses : desktopClasses}`}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

export default NavItem;